import {
  createCommandAsyncThunk,
  createQueryAsyncThunk,
} from "../../../app/createApiAsyncThunk";
import {
  ChangeTargetedShiftSalaryRowCmd,
  DeleteTargetedShiftSalaryRowCmd,
  changeTargetedShiftSalaryRow,
  deleteTargetedShiftSalaryRow,
  getEmpTargetedShiftSpec,
  TargetedShiftSpec,
  TargetedShiftSalaryRowChanged,
  getCanSetTargetingForEmployment,
  CanSetTargetingForEmployment,
  CanSetTargetingForEmploymentPayload,
} from "./targetedShiftSalariesApi";

export const fetchEmpTargetedShiftSpec = createQueryAsyncThunk<
  TargetedShiftSpec,
  { employmentId: string }
>("targetedShiftSalaries/fetch", getEmpTargetedShiftSpec);

export const saveTargetedShiftSalaryRow = createCommandAsyncThunk<
  ChangeTargetedShiftSalaryRowCmd,
  TargetedShiftSalaryRowChanged
>("targetedShiftSalaries/save", changeTargetedShiftSalaryRow);

export const removeTargetedShiftSalaryRow = createCommandAsyncThunk<
  DeleteTargetedShiftSalaryRowCmd,
  TargetedShiftSalaryRowChanged
>("targetedShiftSalaries/delete", deleteTargetedShiftSalaryRow);

export const fetchCanSetTargetingForEmployment = createQueryAsyncThunk<
  CanSetTargetingForEmployment,
  CanSetTargetingForEmploymentPayload
>(
  "targetedShiftSalaries/fetchCanSetTargeting",
  getCanSetTargetingForEmployment,
);
